import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';
import { serializeNodesToHtml } from '@plone/volto-slate/editor/render';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import mapSVG from '@plone/volto/icons/map.svg';
import './localizzazione.css';

// Carica Leaflet solo lato client (evita errori SSR)
const MapComponent = loadable(() => import('./MapComponent'), { ssr: false });

const View = (props) => {
  const { data } = props;
  const [coordinates, setCoordinates] = useState([44.809984, 10.323001]);
  const title = data.title || '';
  const dotsPosition = data.dotsPosition || 'both';
  const titleAlignment = data.titleAlignment || 'left';
  const titleDimension = data.titleDimension || 'h2';
  const cardBackground = data.cardBackground || 'no-background';

  useEffect(() => {
    if (Array.isArray(data.coordinates) && data.coordinates.length === 2) {
      setCoordinates(data.coordinates);
    }
  }, [data.coordinates]);

  const fullAddress = `${data.street || ''}, ${data.zipCode || ''} ${data.city || ''}`;

  // Gestione del campo description
  let descriptionHTML = 'Descrizione non disponibile';
  if (data.description) {
    if (typeof data.description === 'string') {
      descriptionHTML = data.description; // Testo semplice (compatibilità con dati vecchi)
    } else if (typeof data.description === 'object' && data.description.data) {
      if (typeof data.description.data === 'string') {
        descriptionHTML = data.description.data; // HTML salvato precedentemente
      } else if (Array.isArray(data.description.data)) {
        descriptionHTML = serializeNodesToHtml(data.description.data); // Slate JSON
      }
    }
  }

  // Funzione per renderizzare il titolo con il tag dinamico
  const renderTitle = () => {
    const TitleTag = titleDimension; // h2, h3, o h4
    return (
      <TitleTag className="title-dots-map">{title}</TitleTag>
    );    
  };

  const renderIconFromTipoElementi = () => {
      switch (data.tipoElementi) {
        case 'baby':
          return <svg className="blue-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"/></svg>;
        case 'circle':
          return <svg className="blue-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"/></svg>;
        case 'spinner':
          return <svg className="blue-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"/></svg>;
        default:
          return null;
      }
    };

    const renderIconFromTipoElementiDopo = () => {
      switch (data.tipoElementi) {
        case 'baby':
          return <svg className="yellow-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"/></svg>;
        case 'circle':
          return <svg className="yellow-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"/></svg>;
        case 'spinner':
          return <svg className="yellow-child" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"/></svg>;
        default:
          return null;
      }
    };

  // Determina se serve il wrapper per lo sfondo
  const needsBackgroundWrapper = cardBackground === 'blue-background' || cardBackground === 'pastel-blue-background';
  const wrapperClasses = needsBackgroundWrapper ? `full-width-background-wrapper ${cardBackground}` : '';

  const content = (
    <div className="block-localizzazione">
      <div style={{ display: 'flex', flexDirection: data.mapPosition === 'left' ? 'row' : 'row-reverse' }} className='localizzazione-container'>
        <div style={{ flex: 1, height: '400px' }} className='localizzazione-map'>
          <MapComponent coordinates={coordinates} address={fullAddress} />
        </div>
        <div style={{ flex: 1, padding: '10px' }}>
          
          {title && (
            <div className={`title-section ${titleAlignment} ${dotsPosition}`}>
              {(dotsPosition === 'before' || dotsPosition === 'both') && (
                <span className="title-dots before">                 
                  {renderIconFromTipoElementi()}
                </span>
              )}

              {renderTitle()}

              {(dotsPosition === 'after' || dotsPosition === 'both') && (
                <span className="title-dots after">                 
                  {renderIconFromTipoElementiDopo()}
                </span>
              )}
            </div>
          )}

          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: descriptionHTML }}
          />
                    
          {/* Card-teaser spostato qui sotto description */}
          <div className="card card-teaser shadow mt-3 rounded">
            <div className="card-body-custom">
              <Icon name={mapSVG} size="32px" className="card-icon" />
              <div className="card-content">
                <h3 className="card-title h5">                
                    {data.titlePlace}               
                </h3>
                <div className="card-text">
                  <p>{fullAddress}</p>                 
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );

  return needsBackgroundWrapper ? (
    <div className={wrapperClasses}>
      <div className='image-card-listing-container'>
        {content}
      </div>
    </div>
  ) : content;
};

export default View;